import type React from 'react';

/**
 * Web StyleSheet 를 inline 에서 쓰는 용도입니다.
 *
 * @deprecated unistyles 사용
 */
export namespace AStyleSheet {
  type NamedStyles<T> = Readonly<{ [P in keyof T]: React.CSSProperties }>;

  export const create = <T extends NamedStyles<T> | NamedStyles<any>>(styles: T): T => {
    return styles;
  };
}
